import qs from 'qs'

const fields = [
  'title',
  'slug',
  'urlToShop',
  'datePublished',
  'widthInMm',
  'heightInMm',
  'locale'
]

const populate = {
  coverImage: true,
  file: true,
  publicationCategory: true,
  ...queryFragmentBiennialEntryThumbnail,
}

export const queryPublicationEntriesThumbnail = (options: queryOptions) => {
  const query = qs.stringify(
    {
      sort: ['datePublished:desc', 'title:asc'],
      pagination: {
        page: options?.page || 1,
        pageSize: options?.pageSize || 20
      },
      filters: {
        $and: [
          {
            biennialEntry: {
              id: {
                $eq: options.filterId
              }
            },
          },
          {
            publicationCategory: {
              id: {
                $eq: options.filterIdSecondary
              }
            }
          }
        ]
      },
      fields,
      populate: {
        ...populate,
        localizations: {
          fields,
        },
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `publication-entries?${query}`
}
